<template>
  <div class="Echarts">
    <div :id="echartId" style="width: 100%;height:100%;" ref="ech"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props: {
    echartId: {
      type: String,
      default: "",
    },
    getpicData: {
      type: Array,
      default: "",
    },
    startTime: {
      type: String,
      default: "",
    },
    endTime: {
      type: String,
      default: "",
    },
    // getKlineData: {
    //   type: Array,
    //   default: ""
    // }
  },
  data() {
    return {
      //  startTime: 0,
      // endTime: 100,
      upColor: "#ec0000",
      downColor: "#00da3c",
      dataCount: 20,
      quoteData: [],
      rightColor: {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#ec0000", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#ec0000", // 100% 处的颜色
            },
          ],
          global: false, // 渐变为 false
        },
        barBorderRadius: 0,
      },
      leftColor: {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#00da3c", // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#00da3c", // 100% 处的颜色
            },
          ],
          global: false, // 渐变为 false
        },
        barBorderRadius: 0, //[0, 0, 30, 30]设置圆角
      },
    };
  },
  methods: {
    Max(value) {
      let maxStr = +`${parseInt(Math.abs(value.max))}`[0] + 1;
      let minStr = +`${parseInt(Math.abs(value.min))}`[0] + 1;
      for (let i = 0; i < `${Math.ceil(Math.abs(value.max))}`.length - 1; i++) {
        maxStr += "0";
      }
      for (let i = 0; i < `${Math.ceil(Math.abs(value.min))}`.length - 1; i++) {
        minStr += "0";
      }
      return Math.abs(value.max) > Math.abs(value.min) ? +maxStr : +minStr;
    },
    Min(value) {
      let maxStr = +`${parseInt(Math.abs(value.max))}`[0] + 1;
      let minStr = +`${parseInt(Math.abs(value.min))}`[0] + 1;
      for (let i = 0; i < `${Math.ceil(Math.abs(value.max))}`.length - 1; i++) {
        maxStr += "0";
      }
      for (let i = 0; i < `${Math.ceil(Math.abs(value.min))}`.length - 1; i++) {
        minStr += "0";
      }
      return value.min >= 0
        ? 0
        : Math.abs(value.max) > Math.abs(value.min)
        ? -+maxStr
        : -+minStr;
    },
    getSeriesData() {
      const series = [];
      const databar = [];
      this.getpicData.forEach((element, idx) => {
        if (element.name == "macdhist") {
          element.tradeValue.map((v) => {
            databar.push({
              value: v,
              itemStyle: v > 0 ? this.rightColor : this.leftColor,
            });
          });
          series.push({
            name: element.name,
            type: "bar",
            data: databar,
            barMaxWidth: 20,
            itemStyle: this.rightColor,
          });
        } else {
          series.push({
            name: element.name,
            type: "line",
            symbol: "none",
            data: element.tradeValue,
          });
        }
      });
      //   {
      //     name: "MA105",
      //     type: "line",
      //     data: [100, 182, -191, 134, 190, 130, -40],
      //     symbolSize: 1,
      //     yAxisIndex: 1
      //   },
      //   {
      //     name: "MA5",
      //     type: "bar",
      //     data: databar,  // databar
      //     barMaxWidth: 20,
      //     itemStyle: rightColor
      //   },
      return series;
    },
    echartsInit() {
      var myChart = this.$echarts.init(document.getElementById(this.echartId));
      var data = [];
      var seriesData = this.getSeriesData();
      var option = {
        title: {
          text: this.getpicData.name,
        },
        backgroundColor: "#fff",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross", // 隐藏鼠标移入的辅助提示线
          },
        },
        // xAxis: [
        //   {
        //     type: "category",

        //     data: this.getpicData[0].tradeTime,
        //     // [
        //     //   "2020/02/01",
        //     //   "2020/02/02",
        //     //   "2020/02/03",
        //     //   "2020/02/04",
        //     //   "2020/02/05",
        //     //   "2020/02/06",
        //     //   "2020/02/07"
        //     // ]

        //     color: "#59588D",
        //     // x轴坐标刻度线
        //     axisTick: {
        //       show: false
        //     },
        //     axisLabel: {
        //       color: "#4d4d4d", // x轴文字颜色
        //       fontSize: 12,
        //       margin: 10 // x轴刻度文字与x轴的距离
        //       // formatter: (value, index) => {
        //       //   return index === 0 ? value : value.slice("5");
        //       // }
        //     },
        //     axisLine: {
        //       lineStyle: {
        //         color: "#ccc" // x轴线颜色
        //       }
        //     }
        //   }
        // ],
        xAxis: {
          data: this.getpicData[0].tradeTime,
        },
        yAxis: {
          scale: true,
          splitLine: { show: true },
        },
        // yAxis: [
        //   {
        //     type: "value",
        //     axisTick: {
        //       show: false
        //     },
        //     // axisLine: {
        //     //   show: false // 隐藏y轴线
        //     // },
        //     axisLabel: {
        //       color: "#4d4d4d"
        //     },
        //     splitLine: {
        //       lineStyle: {
        //         color: "#ccc" // 背景横线颜色
        //       }
        //     },
        //     scale: true,
        //     // 计算左侧y轴对应的柱状图数据的最大值
        //     max: value => this.Max(value),
        //     min: value => this.Min(value)
        //   },
        //   {
        //     type: "value",
        //     position: "left",
        //     axisTick: {
        //       show: false
        //     },
        //     axisLine: {
        //       show: false
        //     },
        //     axisLabel: {
        //       show: true,
        //       color: "#4d4d4d",
        //       formatter: "{value}" // right Y轴
        //     },
        //     splitLine: {
        //       lineStyle: {
        //         color: "#ccc"
        //       }
        //     },
        //     scale: true,
        //     // 右侧y轴百分比对应折线图的最大最小值
        //     max: value => this.Max(value),
        //     min: value => this.Min(value)
        //   }
        // ],
        // dataZoom: {
        //   type: "inside",
        //   show: true,
        //   realtime: true,
        //   end: this.endTime,
        //   start: this.startTime
        // },
        dataZoom: [
          {
            type: "slider",
            start: this.startTime,
            end: this.endTime,
          },
          {
            type: "inside",
            start: this.startTime,
            end: this.endTime,
          },
        ],
        series: seriesData,
        //  [
        //   {
        //     name: "MA5",
        //     type: "bar",
        //     data: databar,  // databar
        //     barMaxWidth: 20,
        //     itemStyle: rightColor
        //   },
        //   {
        //     name: "MA15",
        //     type: "line",
        //     data: [10, 82, -91, 34, 90, 30, -40],
        //     // smooth: false, //是否平滑曲线显示
        //     // showSymbol: false, // false 表示只有在tooltip hover的时候显示
        //     symbolSize: 1,
        //     yAxisIndex: 1,
        //     // lineStyle: {
        //     //     color: '#fe9a8b',
        //     //     width: 1
        //     // }, //折线颜色粗细
        //     // itemStyle: {
        //     //     color: '#000',
        //     //     borderColor: '#fe9a8b'
        //     // } //拐点颜色边框样式
        //   },
        //   {
        //     name: "MA105",
        //     type: "line",
        //     data: [100, 182, -191, 134, 190, 130, -40],
        //     symbolSize: 1,
        //     yAxisIndex: 1
        //   }
        // ]
      };
      myChart.setOption(option, true);
    },
    myChartZoom() {
      const myChart = this.$echarts.init(
        document.getElementById(this.echartId)
      );
      const than = this;
      myChart.on("datazoom", function (params) {
        params = params.batch ? params.batch[0] : params;
        than.$emit("onZoomInit", params);
      });
    },
  },

  mounted() {
    this.echartsInit();
    this.myChartZoom();
    window.addEventListener("resize", () => {
      this.$echarts.init(document.getElementById(this.echartId)).resize();
    });
  },
};
</script>
<style lang="less" scoped>
.Echarts {
  margin: 0 0 20px 0;
  height: 100%;
  width: 100%;
}
</style>
